import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteCategoryApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteCategory = createAsyncThunk('deleteCategory', async (payload) => {
  return await deleteCategoryApi(payload);
});

const deleteCategorySlice = createSlice({
  name: 'deleteCategory', // Unique Name
  initialState,
  reducers: {
    deleteCategoryReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteCategory.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteCategory.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteCategoryReset } = deleteCategorySlice.actions;

export default deleteCategorySlice.reducer;
